import { PageContainer } from "@shapr3d/frontend-lib";

import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import EduRequestContainer from "../containers/EduRequestContainer";

const EduRequestPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <PageContainer>
        <EduRequestContainer />
      </PageContainer>
    </UnderMaintenanceOrChildren>
  );
};

export default EduRequestPage;
